import React from 'react'
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

export const MemberCircleChevronRightIcon: React.FC = () => {
  return <FontAwesomeIcon icon={faCircleChevronRight} size={'lg'}/>
}
